<template>
  <v-btn color="primary" @click="$router.back()" v-if="canGoBack">
    <v-icon v-html="`mdi-backburger`" />
    {{ $t('button.go_back') }}
  </v-btn>
</template>
<script>

export default {
  name: 'GoBackButton',

  computed: {
    canGoBack () {
      return window.navigation.canGoBack
    }
  }

}
</script>
